/**
 * Single source of truth for travel holidays.
 *
 * Each holiday maps to:
 * - `months` — calendar months (1-12) when the holiday typically falls.
 *   Used by API to filter trips by holiday window.
 * - `label` — UI display text. Used by web filter sidebar dropdown.
 */
export const HOLIDAYS_CONFIG = {
  easter: { months: [3, 4], label: "Easter" },
  christmas: { months: [12, 1], label: "Christmas / New Year" },
  "spring-break": { months: [2, 3], label: "Spring Break" },
  "may-holidays": { months: [5], label: "May Holidays" },
  "autumn-break": { months: [10, 11], label: "Autumn Break" },
  "summer-break": { months: [6, 7, 8], label: "Summer Holidays" },
} as const satisfies Record<string, { months: readonly number[]; label: string }>;

export type HolidayId = keyof typeof HOLIDAYS_CONFIG;

// Lookups come from URL params (untrusted strings) → loose Record<string>; unknown ids return undefined.
export const HOLIDAY_MONTH_MAP: Record<string, readonly number[] | undefined> = Object.fromEntries(
  Object.entries(HOLIDAYS_CONFIG).map(([id, { months }]) => [id, months]),
);

export const HOLIDAYS_UI: ReadonlyArray<{ value: HolidayId; label: string }> = Object.entries(
  HOLIDAYS_CONFIG,
).map(([value, { label }]) => ({ value: value as HolidayId, label }));
